function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 0.514893C2.23858 0.514893 0 2.75347 0 5.51489V20.5149C0 23.2763 2.23858 25.5149 5 25.5149H24L24 0.514893H5Z",
  fill: "#18A43B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 0.514893L26 25.5149H43C45.7614 25.5149 48 23.2763 48 20.5149V5.51489C48 2.75347 45.7614 0.514893 43 0.514893H26Z",
  fill: "#18A43B"
});

var Svg2CActive = function Svg2CActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 26,
    viewBox: "0 0 48 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2CActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2c_active.d17854ac.svg";
export { ForwardRef as ReactComponent };